import dayjs, { Dayjs } from 'dayjs';

import {
  ActivityAnalyzeCheckedActivities,
  ActivityAnalyzeRangeFilters,
  ActivityAnalyzeLocalStorageSchema,
} from 'business/shift-report/report-analyze/pages/activity-analyze/providers/filters/types';
import logger from 'technical/logger';
import { DateRangeValue } from 'technical/types';

const safeStringToDayjs = (dateString: Dayjs | string | undefined | null) => {
  try {
    const date = dayjs(dateString as any);
    if (!date.isValid()) {
      return null;
    }
    return date;
  } catch (error) {
    logger.error(error);
    return null;
  }
};

export const parseActivityAnalyzeCheckedActivities = (
  localStorageCheckedActivities:
    | ActivityAnalyzeLocalStorageSchema['checkedActivities']
    | null,
): ActivityAnalyzeCheckedActivities | null => {
  if (!localStorageCheckedActivities) {
    return null;
  }

  return localStorageCheckedActivities;
};

export const parseActivityAnalyzeFilters = (
  localStorageFilters: ActivityAnalyzeLocalStorageSchema['filters'] | null,
): ActivityAnalyzeRangeFilters | null => {
  if (!localStorageFilters) {
    return null;
  }

  const dateRange: DateRangeValue = localStorageFilters.dateRange
    ? [
        localStorageFilters.dateRange?.at(0)
          ? safeStringToDayjs(localStorageFilters.dateRange?.at(0))
          : null,
        localStorageFilters.dateRange?.at(1)
          ? safeStringToDayjs(localStorageFilters.dateRange?.at(1))
          : null,
      ]
    : null;

  // @ts-ignore
  return {
    ...localStorageFilters,
    dateRange,
  };
};
